import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, Subject, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { GlobalService } from "./global.service";

const devUrl = environment.backendurl

export interface GetJobListingPaylod {
    startindex: number,
    limit: number,
    jobname?: string,
};

export interface GetCandidateListingPaylod {
    startindex: number,
    limit: number,
    jobid: string,
    category: string,
    search: string
};

export interface syncJobCandidatePayload {

}



@Injectable({
    providedIn: 'root'
})

export class AtsResumeScreenService {

    constructor(private http: HttpClient, private router: Router) { }

    private candidateReRunObservable: Subject<any> = new Subject();

    get getCandidateReRunEvent(): Observable<any> {
        return this.candidateReRunObservable.asObservable();
    }

    emitCandidateReRunEvent(data: any) {
        this.candidateReRunObservable.next(data);
    };

    /**
     * Get job list from ATS
     */
    getJobsList(data: any) {
        const url = devUrl + `/unified/integrations/jobs/status`;

        return this.http.post<any>(url, data).pipe(
            map(response => ({ ...response, statusCode: response.status })),
            catchError((err: HttpErrorResponse) => throwError(err))
        );
    };


    /**
     * Get job list from ATS
     */
    startScreening(data: any) {
        const url = devUrl + `/unified/integrations/sync`;

        return this.http.post<any>(url, data).pipe(
            map(response => ({ ...response, statusCode: response.status })),
            catchError((err: HttpErrorResponse) => throwError(err))
        );
    };



    /**
     * Get job details
     */
    getJobDetails(jobid: string) {
        const url = devUrl + `/unified/integrations/jobs/${jobid}`;

        return this.http.get<any>(url).pipe(
            map(response => ({ ...response, statusCode: response.status })),
            catchError((err: HttpErrorResponse) => throwError(err))
        );
    };


    /**
     * Import jobs list from ATS
     */
    getModelJobsList() {
        const url = devUrl + `/unified/integrations/all/jobs`;
        return this.http.get<any>(url).pipe(
            map(response => ({ ...response, statusCode: response.status })),
            catchError((err: HttpErrorResponse) => throwError(err))
        );
    };



    /**
     * Get candidate list as per jobs
     */
    getCandidateList(data) {
        const url = devUrl + `/unified/integrations/candidates/job/${data.jobid}`;

        return this.http.post<any>(url, data).pipe(
            map(response => ({ ...response, statusCode: response.status })),
            catchError((err: HttpErrorResponse) => throwError(err))
        );
    };



    /**
     * Method to make api call for sync job candidate
     */
    insertJobInATS(data: any) {
        const url = devUrl + `/unified/integrations/jobs/insert`;
        return this.http.post<any>(url, data).pipe(
            map(response => ({ ...response, statusCode: response.status })),
            catchError((err: HttpErrorResponse) => throwError(err))
        );
    };

    /**
     * Method to make api call for sync job candidate
     */
    updateJobScreeningCriteria(data: any, jobId: string) {
        const url = devUrl + `/unified/integrations/job/${jobId}/evaluationcriteria`;
        return this.http.put<any>(url, data, { observe: 'response' }).pipe(
            map(response => ({ ...response, statusCode: response.status })),
            catchError((err: HttpErrorResponse) => throwError(err))
        );
    };


    getSingleJobDetails(jobid: string) {
        const url = devUrl + `/unified/integrations/jobs/ats/${jobid}`;
        return this.http.get<any>(url, { observe: 'response' }).pipe(
            map(response => ({ ...response, statusCode: response.status })),
            catchError((err: HttpErrorResponse) => throwError(err))
        );
    }


    /**
     * Upload resume in bulk
     * @param data
     * @param jobid
     * @returns
     */
    resumeScreeningUploadResume(data: any, jobid: string) {
        let formData: FormData = new FormData();
        formData.append('resume', data);
        var url = devUrl + `/unified/integrations/${jobid}/upload/resumes`
        return this.http.post<any>(url, formData, { observe: 'response' }).pipe(map(response => ({ ...response, statusCode: response.status }))
            , catchError(GlobalService.handleError('Document Upload', url)));
    };

    /**
     * Create bulk candidate with uploaded resume
     * @param data
     * @param jobid
     * @returns
     */
    createBulkCandidate(data: any, jobid: string) {
        var url = devUrl + `/unified/integrations/${jobid}/createcandidate/bulk`;
        return this.http.post<any>(url, data, { observe: 'response' }).pipe(map(response => ({ ...response, statusCode: response.status }))
            , catchError(GlobalService.handleError('Document Upload', url)));
    };

    /**
      * Method to rename a job.
      * @param jobnumber
      * @param jobname
      */
    renameJob(jobnumber: string, jobname: any) {
        const url = devUrl + `/unified/integrations/job/${jobnumber}/rename`;
        return this.http.put<any>(url, jobname, { observe: 'response' }).pipe(map(response => ({ ...response, statusCode: response.status }))
            , catchError((err: HttpErrorResponse) => throwError(err)));
    };


    /**
     * Sync Candidate to the job
     */
    syncCandidate(jobid: string) {
        const url = devUrl + `/unified/integrations/job/${jobid}/status`;
        return this.http.get<any>(url, { observe: 'response' }).pipe(
            map(response => ({ ...response, statusCode: response.status })),
            catchError((err: HttpErrorResponse) => throwError(err))
        );
    }


    previewCandidateResume(candidateId: string, docurl: string) {
        var url = devUrl + `/unified/integrations/${candidateId}/candidate/download?url=` + docurl;
        return this.http.get(url, { responseType: 'blob' }).pipe(
            map((response: any) => { return response })

            , catchError(GlobalService.handleError('resumeurl', url)));
    }

    reRunScreening(data:any){
      const url = devUrl + `/unified/integrations/job/rerunscreening`;
       return this.http.post<any>(url, data, { observe: 'response' }).pipe(map(response => ({ ...response, statusCode: response.status }))
            , catchError(GlobalService.handleError('Document Upload', url)));
    }


    getPreviewCandidateDoc(data: any) {
        const url = devUrl + `/unified/integrations/candidate/fetchdocument`;
        let params = new HttpParams()
            .set('url', data?.url)
            .set('filename', data?.filename);

        return this.http.get(url, { params, responseType: 'blob' }).pipe(
            map((response: any) => { return response })
            , catchError(GlobalService.handleError('Preview documents', url)));
    };
    
    /**
     * fetches job details based on the sources
     * @param source 
     */
    getAllScreenAIJobsBySource(query: string = '', source:string = 'create'){
      const url = devUrl + `/unified/integrations/jobs?query=${query}&source=${source}`;
      return this.http.get<any>(url).pipe(
        map(response => ({ ...response, statusCode: response.status })),
        catchError((err: HttpErrorResponse) => throwError(err))
      );
    }

    /**
     * Check for duplicate candidates before adding to ScreenAI job
     * @param data - { firstname, lastname, companyname, title }
     */
    checkDuplicateCandidate(data: { candidateDetails: { firstname: string, lastname: string, companyname: string, title: string }[], jobnumber: string }) {
      const url = devUrl + `/unified/integrations/candidate/duplicatecheck`;
      return this.http.post<any>(url, data).pipe(
        map(response => ({ ...response, statusCode: response.status })),
        catchError((err: HttpErrorResponse) => throwError(err))
      );
    }

    /**
     * Add candidates to a ScreenAI job
     * @param data - { jobnumber, candidateinfo: [{ elasticid, source }] }
     */
    addCandidatesToScreenAI(data: { jobnumber: string, candidateinfo: { elasticid: string, source: string }[], isComingFrom?: string }) {
      const url = devUrl + `/unified/integrations/candidate/addtoscreenai`;
      return this.http.post<any>(url, data).pipe(
        map(response => ({ ...response, statusCode: response.status })),
        catchError((err: HttpErrorResponse) => throwError(err))
      );
    }

}
